// @vue/component
import Daochu from "../daochu/daochu";
export default {
  name: "Top",

  components: { Daochu },

  mixins: [],

  props: {
    project: {
      type: Object,
      require: true
    },
    select_list: {
      type: Array,
      require: true
    }
  },

  data() {
    return {
      key: "",
      exportDialogVisible: false
    };
  },

  computed: {},

  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.serch, 500);
    }
  },

  created() {},

  methods: {
    serch(){
      this.$emit("refresh", this.key)
    }
  }
};
